import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { Routes, Route } from "react-router";
import s from "./Body.module.css"
import menu_data from "../../../routes/routes";

export default function Body({stopEvents, setStopEvents}){
    const location = useLocation();
    const [displayLocation, setDisplayLocation] = useState(location);
    const [transitionStage, setTransistionStage] = useState("");

    useEffect(() => {
        if (location !== displayLocation && !stopEvents){
            setStopEvents(true)
            let current = menu_data.map(item => item.url).indexOf(location.pathname)
            let next = menu_data.map(item => item.url).indexOf(displayLocation.pathname)
            setTransistionStage(next < current? "fadeOutT" : "fadeOutB");
        } 
    }, [location, displayLocation, stopEvents]);

    return (
        <div
        className={s[transitionStage]}
        style={{width: '100%', height: '100%'}}
        onAnimationEnd={() => {
            if (transitionStage === "fadeOutB") {
            setTransistionStage("fadeInB");
            setDisplayLocation(location);
            setStopEvents(false)
            }
            if(transitionStage === "fadeOutT"){
            setTransistionStage("fadeInT");
            setDisplayLocation(location);
            setStopEvents(false)
            }
        }}
        >
        <Routes location={displayLocation}>
            {menu_data?.map((item, index) => {
                return(
                    <Route path={item.url} element={item.element} key={index}/>
                )
            })}
        </Routes>
        </div>
    );
}